import {
  Box,
  Center,
  Spinner,
  type SpinnerProps,
  type SystemStyleObject,
} from '@chakra-ui/react';

export const loadingCss: SystemStyleObject = {
  '&': {
    position: 'absolute',
    inset: '0',
    bg: 'bg/80',
  },

  '& .Center': { height: 'full' },
};

type LoadingProps = {
  css?: SystemStyleObject;
  spinnerProps?: SpinnerProps;
};

/**
 * Displays a loading spinner that covers the entire viewport.
 *
 * @see https://chakra-ui.com/docs/components/spinner#overlay
 */
export const Loading = ({ css = loadingCss, spinnerProps }: LoadingProps) => (
  <Box
    className="Loading"
    aria-label="Loading"
    data-testid="Loading"
    role="progressbar"
    css={css}
  >
    <Center className="Center">
      <Spinner {...spinnerProps} size={spinnerProps?.size ?? 'lg'} />
    </Center>
  </Box>
);
